module.exports = __webpack_public_path__ + "static/fonts/PingFang SC Regular.8d76ff86.ttf";